import gql from 'graphql-tag'

export const fetchOfficesList = delegation_id => {
	return {
		query: gql`
			query ($delegation_id: bigint!) {
				organizations_offices(
					where: { delegation_id: { _eq: $delegation_id } }
				) {
					office_name
					address
					state_id
					phone
					email
					number
					street
					floor
					door
					city
					zipcode
				}
			}
		`,
		update(data) {
			return {
				...data.organizations_offices
			}
		},
		variables() {
			return {
				delegation_id
			}
		}
	}
}
